import colors from './colors';
import { createDict } from '../utils';
// Border Radius
export var borderRadius = {
  radius4: '4px',
  radius8: '8px',
  radius24: '24px',
  radiusRound: '999px'
}; // Borders

export var borderPrimitives = {
  border1: '1px',
  border2: '2px',
  border4: '4px'
};
export var borders = createDict(Object.keys(borderPrimitives).map(function (weight) {
  return [weight, [borderPrimitives[weight], 'solid'].join(' ')];
}));
export var bordersAsShadows = createDict(Object.keys(borderPrimitives).map(function (weight) {
  return [weight, ['0 0 0', borderPrimitives[weight]].join(' ')];
})); // Shadows

export var shadowPrimitives = {
  shadow4: {
    sizes: "0px 1px 4px 0px",
    colorToken: 'shadowPrimary'
  },
  shadow8: {
    sizes: "0px 2px 8px 0px",
    colorToken: 'shadowPrimary'
  },
  shadow8Button: {
    sizes: "0px 2px 8px 0px",
    colorToken: 'shadowButton'
  },
  shadow16: {
    sizes: "0px 4px 16px 0px",
    colorToken: 'shadowPrimary'
  }
};

function shadowsWithMode(mode) {
  return createDict(Object.keys(shadowPrimitives).map(function (size) {
    var shadowPrimitive = shadowPrimitives[size];
    return [size, [shadowPrimitive.sizes, colors[mode][shadowPrimitive.colorToken]].join(' ')];
  }));
}

export var shadows = {
  light: shadowsWithMode('light'),
  dark: shadowsWithMode('dark')
};